import React from 'react';
import '../../styles/brokerage.css'; // Import Brokerage specific CSS
import '../../styles/Fonts.css'; // Import Fonts specific CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome

const benefitsData = [
  {
    number: '01',
    title: 'Expert Compliance',
    description: 'Professional handling of customs documentation and regulatory requirements.',
    icon: 'fa-file-contract'
  },
  {
    number: '02',
    title: 'Regulatory Knowledge',
    description: 'Deep expertise in international trade laws and customs procedures.',
    icon: 'fa-graduation-cap'
  },
  {
    number: '03',
    title: 'Fast Clearance',
    description: 'Expedited customs processing to minimize shipment delays.',
    icon: 'fa-clock'
  },
  {
    number: '04',
    title: 'Cost Efficiency',
    description: 'Optimized duty management and penalty avoidance through expert guidance.',
    icon: 'fa-hand-holding-dollar'
  }
];

const BrokerageBenefits = () => {
  return (
    <>
      {/* Brokerage Benefits Section */}
      <section id="benefits" className="services-preview-section">
        <div className="container">
          <div className="section-header">
            <div className="section-badge">WHY CHOOSE US</div>
            <h2 className="section-title">Brokerage Benefits</h2>
            <p className="section-description">
              Discover the key advantages of partnering with RCS Logistics for your customs brokerage needs.
            </p>
          </div>

          <div className="services-cards-grid brokerage-benefits">
            {benefitsData.map((benefit, index) => (
              <div key={index} className="service-card">
                <div className="service-card-icon">
                  <i className={`fas ${benefit.icon}`}></i>
                </div>
                <h3 className="service-card-title">{benefit.title}</h3>
                <p className="service-card-description">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default BrokerageBenefits;
